module.exports = __webpack_public_path__ + "static/img/nav_pic3.8af1a14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/nav_pic3.jpg
// module id = iBOC
// module chunks = 37